
import React from "react";
import Money from "components/money";

const ItemPrices = ({ price, compareAtPrice, currency }) => {
	const hasDiscount = compareAtPrice > price;
	return (
		<div className="flex gap-1 items-center">
			{hasDiscount && (
				<span className="text-xs text-secondary line-through ml-2 text-end">
					<Money value={compareAtPrice} currency={currency} />
				</span>
			)}
			<p className="font-semibold text-end">
				<Money value={price} currency={currency} />
			</p>
		</div>
	);
};

export default ItemPrices;